import getLocalizationByArgs from '@helpers/getLocalizationByArgs';
import { SetUpServiceData } from '@pages/AdditionalServices/containers/methods/basket/types';
import { GROUP_VARIANT_TEMPLATE } from '@pages/History/consts';
import { getCachedShortLinkData } from '@pages/History/helpers';
import { HistoryServicesData } from '@pages/History/types';
import { OrderProduct } from '@services/requests/orderService/orderProductsLoader/interface';
import { shortLinkService } from '@services/requests/shortLinkService';

/**
 * Данные расчета доп. услуг по короткой ссылке
 */
export const loadHistoryServicesData = (shortLink: string): Promise<HistoryServicesData> => {
  const loadServicesData = async (): Promise<HistoryServicesData> => {
    const shortLinkData = await shortLinkService().LoadShortLink({ id: shortLink });

    if (!shortLinkData?.data) {
      throw new Error(`Short link data not found: ${shortLink}`);
    }

    const servicesData = JSON.parse(shortLinkData.data);

    if (!Array.isArray(servicesData) || servicesData.length === 0) {
      throw new Error(`Short link data is invalid: ${shortLink}`);
    }

    return servicesData;
  };

  return getCachedShortLinkData(shortLink, loadServicesData);
};

/**
 * Продукт для restoreServiceData из данных короткой ссылки.
 * Шаблон group — как группа (complex), остальные — как одиночная услуга.
 */
export const makeHistoryServiceProduct = (services: HistoryServicesData): OrderProduct => {
  const setUpService = services.find((s: SetUpServiceData) => s?.IsSetupService) as
    | SetUpServiceData
    | undefined;

  const isGroup = setUpService?.Variant?.template === GROUP_VARIANT_TEMPLATE;

  return {
    id: '',
    amount: 1,
    price: 0,
    token: '',
    product_type: isGroup ? 'complex' : 'service',
    data: isGroup
      ? JSON.stringify(services.map((s) => ({ data: JSON.stringify(s) })))
      : JSON.stringify(setUpService ?? services[0]),
  };
};

/**
 * Путь услуги из директорий и выбранного варианта
 */
export const getHistoryServicePath = (langId: string, setUpService: SetUpServiceData): string => {
  const directories = Object.keys(setUpService.ServicesPath ?? {})
    .sort((a, b) => Number(a) - Number(b))
    .map((level) => setUpService.ServicesPath[level])
    .filter((directory) => !!directory);

  const lastDirectory = directories[directories.length - 1];
  const variant = setUpService.Variant;

  if (variant && variant.id !== lastDirectory?.id) {
    directories.push(variant);
  }

  return directories
    .map((directory) => getLocalizationByArgs(langId, directory.name, directory.localized_names))
    .filter((name) => name.length > 0)
    .join(' - ');
};
